// eslint-disable-next-line import/prefer-default-export
// TODO: Delete this file after all forms have moved to HubSpot
export const MODAL_DOWNLOAD_FORM_ID = '5';
export const DOWNLOAD_THE_GUIDE_FORM_ID = '6';
